// extracted by mini-css-extract-plugin
module.exports = {"flag":"N7uJkm","flagImage":"_1TtEef","flagBody":"_1kL2QY","flagTop":"_1x_yFP","flagBottom":"_14RKO4","flagRev":"_1ouMLB"};